import { render } from "./ContentTemplates.vue?vue&type=template&id=0b6ebb92"
import script from "./ContentTemplates.vue?vue&type=script&lang=js"
export * from "./ContentTemplates.vue?vue&type=script&lang=js"

import "./ContentTemplates.vue?vue&type=style&index=0&id=0b6ebb92&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__